/* ==========================================================================
   SearcherFlightHotel > Client > Button
   ========================================================================== */

/* Modules */
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button/client/js');
const { getAirportByDestination } = require('./services');

/* Init */
function initButton(selector, instance) {
    const inst = instance;
    document.querySelector(selector).addEventListener('click', () => {
        const { config = {}, location } = instance;
        const { submitUrl = {} } = config;

        const validationResult = validateFields(instance);

        if (!validationResult.success) return;

        const params = {
            productType: 'FlightHotel',
            hotelCode: instance.config.hotelCode || instance.element.getAttribute('data-hotelcode'),
            originAirportCode: instance.location[0].value,
            hashRooms: getHashRooms(instance.accommodation.panelAccommodation.accommodation.roomStore),
            destinationType: instance.location[1].kind || instance.config.location.destination.type,
            destinationCode: instance.location[1].value,
            departureDateStr: dateFormat(instance.calendar.fp.selectedDates[0]),
            returnDateStr: dateFormat(instance.calendar.fp.selectedDates[1]),
            FamilyDiscount: instance.discounts.get().value,
            CabinClass: instance.class && instance.class.value ? instance.class.value : '',
            LineOfBusiness: 'Packages',
            company: instance.element.getAttribute('data-company') || '',
            hotelChain: instance.element.getAttribute('data-hotel-chain') || ''
        };

        if (instance.config.selectedAirlines) params.selectedAirlines = instance.config.selectedAirlines;

        const urlParams = paramsDictToUrl(params);
        // TODO: Do validations and execute next line if all ok.

        inst.subscriptionLocation = getAirportByDestination(inst).subscribe({
            next: response => {
                const { code } = response;
                const validationResults = validateFields(instance);

                const { value: valueOrigin } = location[0];

                if (code !== valueOrigin) {
                    if (validationResults.success) {
                        window.location.assign(`${submitUrl}?${urlParams}`);
                    } else {
                        validationResults.fieldsError.forEach(field => field.setError());
                    }

                    // Modal Loading
                    instance.loading.setContentTemplate(instance);
                    instance.loading.modal.start();
                }
            },
            error: err => console.error(`${'Error API Packages Discounts'}${err}`)
        });
    });

    return ButtonClient(selector);
}

function validateFields(instance) {
    const result = {
        success: true,
        fieldsError: []
    };

    if (instance.location[0].get().content === undefined || instance.location[0].input.get() === '') {
        result.success = false;
        result.fieldsError.push(instance.location[0]);
        instance.location[0].setError();
    }

    if (
        instance.location[1].get().content === undefined ||
        instance.location[1].value === '' ||
        instance.location[1].input.get() === ''
    ) {
        result.success = false;
        result.fieldsError.push(instance.location[1]);
        instance.location[1].setError();
    }

    if (instance.calendar.get().length === 0) {
        result.success = false;
        result.fieldsError.push(instance.calendar);
        instance.calendar.input.setError();
    }

    return result;
}

// TODO: Move to helper
function paramsDictToUrl(params) {
    const arrParams = [];

    Object.keys(params).forEach(key => {
        if (params[key] !== '') arrParams.push(`${key}=${params[key]}`);
    });

    return arrParams.join('&');
}

function dateFormat(date) {
    const month = formatDateDigits(date.getMonth() + 1);
    const day = formatDateDigits(date.getDate());
    return `${date.getFullYear()}-${month}-${day}`;
}

function formatDateDigits(number) {
    let fNumber = `${number}`;
    if (fNumber.length === 1) {
        fNumber = `0${fNumber}`;
    }
    return fNumber;
}

function getHashRooms(roomStore) {
    const hashRoomsArr = [];
    Object.keys(roomStore).forEach(key => {
        hashRoomsArr.push(`${roomStore[key].codeHash.adults}${roomStore[key].codeHash.children}`);
    });
    return hashRoomsArr.join('%2C');
}

module.exports = {
    initButton
};
